import { render, staticRenderFns } from "./ItemsImageCard.vue?vue&type=template&id=f49bca12&"
import script from "./ItemsImageCard.vue?vue&type=script&lang=js&"
export * from "./ItemsImageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports